export const PAYMENT_LOGO_OPTIONS = [
  { id: "visa", label: "Visa" },
  { id: "mastercard", label: "Mastercard" },
  { id: "amex", label: "American Express" },
  { id: "discover", label: "Discover" },
];

export const PAYMENT_LOGO_IDS = PAYMENT_LOGO_OPTIONS.map((o) => o.id);

export function paymentLogoIsHidden(paymentLogo) {
  return Array.isArray(paymentLogo) && paymentLogo.includes("hidden");
}

/** Brand ids present on a logo array (excludes "hidden"). */
export function paymentLogoExplicitBrandIds(paymentLogo) {
  if (!Array.isArray(paymentLogo) || paymentLogoIsHidden(paymentLogo)) {
    return [];
  }
  return PAYMENT_LOGO_IDS.filter((id) => paymentLogo.includes(id));
}

/**
 * Hydrate store UI from API. For multi-store, [] means inherit mothership payment logos.
 * For single-store, [] means no logos.
 */
export function hydrateStorePaymentLogoState(
  storePaymentLogo,
  orgHasMultipleStores,
  merchantPaymentLogo
) {
  if (paymentLogoIsHidden(storePaymentLogo)) {
    return {
      hidden: true,
      useMothershipPaymentLogos: false,
      selectedIds: paymentLogoExplicitBrandIds(merchantPaymentLogo),
    };
  }
  const explicit = paymentLogoExplicitBrandIds(storePaymentLogo);
  if (explicit.length === 0) {
    if (orgHasMultipleStores) {
      return {
        hidden: false,
        useMothershipPaymentLogos: true,
        selectedIds: paymentLogoExplicitBrandIds(merchantPaymentLogo),
      };
    }
    return {
      hidden: false,
      useMothershipPaymentLogos: false,
      selectedIds: [],
    };
  }
  return {
    hidden: false,
    useMothershipPaymentLogos: false,
    selectedIds: explicit,
  };
}

export function buildStorePaymentLogoPayload({
  hidden,
  useMothershipPaymentLogos,
  selectedIds,
  orgHasMultipleStores,
}) {
  if (hidden) return ["hidden"];
  if (orgHasMultipleStores && useMothershipPaymentLogos) return [];
  const uniq = [...new Set(selectedIds)].filter((id) =>
    PAYMENT_LOGO_IDS.includes(id)
  );
  return [...uniq].sort();
}

/** Mothership / merchant: [] = none; all four must be listed explicitly to show all. */
export function buildMerchantPaymentLogoPayload(hidden, selectedIds) {
  if (hidden) return ["hidden"];
  const uniq = [...new Set(selectedIds)].filter((id) =>
    PAYMENT_LOGO_IDS.includes(id)
  );
  return [...uniq].sort();
}

export function merchantPaymentLogoToUi(paymentLogo) {
  if (paymentLogoIsHidden(paymentLogo)) {
    return { hidden: true, selectedIds: [] };
  }
  return {
    hidden: false,
    selectedIds: paymentLogoExplicitBrandIds(paymentLogo),
  };
}

export function stablePaymentLogoJson(logo) {
  if (!Array.isArray(logo)) {
    return "[]";
  }
  if (logo.includes("hidden")) {
    return JSON.stringify(["hidden"]);
  }
  const part = [...PAYMENT_LOGO_IDS.filter((id) => logo.includes(id))].sort();
  return JSON.stringify(part);
}
